const doc = [({"en":({"js":({"admin":({"agenda_item_elements":({"create_card":({"create_agenda_item_element":"Create agenda item element"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;